/* unplugin-vue-components disabled */import script from "./GiftProductSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftProductSettings.vue?vue&type=script&setup=true&lang=js"

import "./GiftProductSettings.vue?vue&type=style&index=0&id=149c74b6&lang=scss"

const __exports__ = script;

export default __exports__